var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
    [
      _vm.fetchLoading
        ? [
            _c(
              "v-col",
              {
                staticClass: "ma-0 pa-0 mt-4",
                staticStyle: { width: "100%", height: "316px" },
                attrs: { cols: "12" },
              },
              [
                _c("v-skeleton-loader", {
                  attrs: {
                    boilerplate: false,
                    elevation: "0",
                    dark: "",
                    type: "image",
                    width: "100%",
                    height: 316,
                  },
                }),
              ],
              1
            ),
          ]
        : [
            _c(
              "v-col",
              {
                staticClass: "ma-0 pa-0 pb-4",
                attrs: { cols: "12", id: "chartBackground" },
              },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "pa-0 mt-4",
                    staticStyle: { position: "relative" },
                    attrs: { id: "main_content_maxwidthset", cols: "12" },
                  },
                  [
                    _vm.showAge == false
                      ? [
                          _c(
                            "v-row",
                            { staticClass: "ma-0 pa-0 pl-2" },
                            [
                              _c(
                                "v-col",
                                { staticClass: "ma-0 pa-0 mt-8 pr-7 pl-9" },
                                [
                                  _c("BarChart", {
                                    attrs: {
                                      "chart-data": _vm.chartData,
                                      options: _vm.chartOptions,
                                      height: 100,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pl-4 pb-2",
                              attrs: {
                                id: "label_box",
                                cols: "12",
                                align: "left",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "1", align: "right" },
                                },
                                [_vm._v(" " + _vm._s("顔認識率") + " ")]
                              ),
                            ],
                            1
                          ),
                        ]
                      : [
                          _c(
                            "v-row",
                            { staticClass: "ma-0 pa-0 pl-4" },
                            [
                              _c(
                                "v-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showAgeValue,
                                      expression: "showAgeValue",
                                    },
                                  ],
                                  staticClass: "ma-0 pa-0 mt-8 pr-7 pl-9",
                                  staticStyle: { height: "595px" },
                                },
                                [
                                  _vm.showAgeValue
                                    ? [
                                        _c("BarChart", {
                                          attrs: {
                                            "chart-data": _vm.chartData,
                                            options: _vm.chartOptions,
                                            height: 235,
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.showAgeValue,
                                      expression: "!showAgeValue",
                                    },
                                  ],
                                  staticClass: "ma-0 pa-0 mt-8 pr-7 pl-9",
                                },
                                [
                                  !_vm.showAgeValue
                                    ? [
                                        _c("BarChart", {
                                          attrs: {
                                            "chart-data": _vm.chartData,
                                            options: _vm.chartOptions,
                                            height: 100,
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _vm.visitorData.length != 0 && _vm.showAgeValue
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pl-4",
                                  attrs: {
                                    id: "label_box",
                                    cols: "12",
                                    align: "left",
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.manOrWoman
                                              ? _vm.ta("man")
                                              : _vm.ta("repeat") + "全体"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("10代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("20代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("30代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("40代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("50代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("60代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("70代以上"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.manOrWoman
                                              ? _vm.ta("woman")
                                              : _vm.ta("new") + "全体"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("10代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("20代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("30代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("40代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("50代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("60代"))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [_vm._v(_vm._s("70代以上"))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.visitorData.length != 0 && !_vm.showAgeValue
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pl-4",
                                  staticStyle: { bottom: "8px" },
                                  attrs: {
                                    id: "label_box",
                                    cols: "12",
                                    align: "left",
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.manOrWoman
                                              ? _vm.ta("man")
                                              : _vm.ta("repeat")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-3",
                                      attrs: { cols: "1", align: "right" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.manOrWoman
                                              ? _vm.ta("woman")
                                              : _vm.ta("new")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                  ],
                  2
                ),
                _vm.mode != "hour" && _vm.mode != "day"
                  ? [
                      _vm.fetchLoading == false && _vm.monthNoData
                        ? _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { id: "no_data", cols: "12" },
                            },
                            [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                          )
                        : _vm._e(),
                    ]
                  : [
                      _vm.visitorData.length == 0 && _vm.fetchLoading == false
                        ? _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { id: "no_data", cols: "12" },
                            },
                            [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                          )
                        : _vm._e(),
                    ],
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }